import React from "react";
import { FormattedMessage } from "react-intl";
import ProductName from "theme/modules/ProductView/ProductName";
import Configurator from "theme/components/organisms/Configurator";
import GroupedItems, {
  hasGroupedItems,
} from "theme/modules/ProductView/GroupedItems";
import AddProductToCart from "./AddProductToCart";
import ErrorBoundary from "theme/components/helpers/ErrorBoundary";
import { ErrorAlert } from "theme/components/molecules/Alert";
import Stack from "theme/components/atoms/Layout/Stack";
import { areAllOptionsSet } from "theme/modules/AddToCart/areAllOptionsSet";
import ProductPriceSeo from "theme/components/atoms/Typography/Price//ProductPriceSeo";

const ProductSynthesis = (props) => {
  const {
    product,
    selectedOptions,
    setOption,
    selectedCustomOptions,
    setCustomOption,
    selectedBundleOptions,
    setBundleOption,
    selectedGroupedItems,
    setGroupedItems,
    onProductAdded,
  } = props;

  return (
    <div className="product-synthesis">
      <div className="container--mobile-only">
        <ErrorBoundary>
          {({ hasError }) => {
            if (hasError) {
              return (
                <>
                  <ProductName product={product} hidePrice={true} />
                  <ErrorAlert>
                    <FormattedMessage
                      id="modules.ProductView.Synthesis.Error"
                      defaultMessage="This product can't be ordered yet, try again later"
                    />
                  </ErrorAlert>
                </>
              );
            }

            return (
              <Stack size="2">
                <ProductName
                  product={product}
                  hasFinalPrice={areAllOptionsSet(
                    product,
                    selectedOptions,
                    selectedCustomOptions,
                    selectedBundleOptions
                  )}
                />
                <div
                  itemProp="offers"
                  itemScope
                  itemType="http://schema.org/Offer"
                >
                  <ProductPriceSeo prices={product.prices} />
                  <Stack size="2">
                    {product.options?.length ||
                    product.custom_options?.length ||
                    product.bundleOptions?.length ? (
                      <Configurator
                        options={product.options}
                        customOptions={product.custom_options}
                        bundleOptions={product.bundleOptions}
                        selectedOptions={selectedOptions}
                        selectedBundleOptions={selectedBundleOptions}
                        selectedCustomOptions={selectedCustomOptions}
                        setOption={setOption}
                        setCustomOption={setCustomOption}
                        setBundleOption={setBundleOption}
                      />
                    ) : null}
                    {hasGroupedItems(product) && (
                      <div className="product__grouped-items">
                        <GroupedItems
                          product={product}
                          selectedGroupedItems={selectedGroupedItems}
                          setGroupedItems={setGroupedItems}
                        />
                      </div>
                    )}
                    {product.stock !== null && product.stock !== undefined && (
                      <AddProductToCart
                        product={product}
                        onProductAdded={onProductAdded}
                        selectedGroupedItems={selectedGroupedItems}
                        selectedOptions={selectedOptions}
                        selectedCustomOptions={selectedCustomOptions}
                        selectedBundleOptions={selectedBundleOptions}
                      />
                    )}
                  </Stack>
                </div>
              </Stack>
            );
          }}
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default ProductSynthesis;
